/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'email': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" d="M9.996 0A10.008 10.008 0 001.95 4.07a9.991 9.991 0 00-1.501 8.887 10.003 10.003 0 006.264 6.485c3 1.045 6.318.606 8.941-1.184l-1.132-1.647a8.018 8.018 0 01-11.908-3.479 8.002 8.002 0 015.778-10.97 8.014 8.014 0 016.665 1.643A8.003 8.003 0 0118.002 10v.782c0 1.39-.599 2.218-1.602 2.218v.017a1.147 1.147 0 00-.19-.016h-.212c-.563 0-1.401-.819-1.401-1.37V10a4.626 4.626 0 00-5.779-4.511 4.624 4.624 0 00.458 9.057 4.634 4.634 0 003.895-1.234c.65.958 1.754 1.691 2.825 1.691v-.017c.064.011.13.017.195.017h.211c2.155 0 3.598-1.691 3.598-4.217V10a10.009 10.009 0 00-2.933-7.066A10.026 10.026 0 009.997 0zm0 12.599a2.6 2.6 0 112.601-2.6 2.6 2.6 0 01-2.6 2.6z" _fill="#203F6A" fill-rule="evenodd"/>'
  }
})
